// Shared React wrapper for the Phaser game canvas
import { useEffect, useRef } from 'react';
import { createGame, destroyGame } from './main';

export function PhaserGame() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    createGame(containerRef.current);
    return () => { destroyGame(); };
  }, []);

  return (
    <div
      ref={containerRef}
      id="phaser-container"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
      }}
    />
  );
}
